import { useMutation, useQuery, useQueryClient } from "react-query";
import { SettingDefinition, UserSettings } from "../../types/userTypes";

import axios from "axios";
import { nuclearn_api_url } from "../../App";

// API functions
const getSettingsDefinitions = (): Promise<SettingDefinition[]> => {
  return axios
    .get(`${nuclearn_api_url}/user/settings/definitions`)
    .then((response) => {
      console.log("Settings definitions response:", response.data);
      return response.data;
    });
};

const getUserSettings = (): Promise<UserSettings> => {
  return axios.get(`${nuclearn_api_url}/user/settings`).then((response) => {
    return response.data;
  });
};

const updateUserSettings = (settings: UserSettings): Promise<UserSettings> => {
  return axios
    .put(`${nuclearn_api_url}/user/settings`, settings)
    .then((response) => {
      console.log("Update settings response:", response.data);
      return response.data;
    });
};

// React Query hooks
export const useGetSettingsDefinitions = () => {
  return useQuery(["settingsDefinitions"], () => getSettingsDefinitions(), {
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 10, // 10 minutes
    cacheTime: 1000 * 60 * 10, // 10 minutes
  });
};

export const useGetUserSettings = () => {
  return useQuery(["userSettings"], () => getUserSettings(), {
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5, // 5 minutes
    cacheTime: 1000 * 60 * 5, // 5 minutes
  });
};

export const useUpdateUserSettings = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(updateUserSettings, {
    onSuccess: (data) => {
      // Update the cache with the new settings
      queryClient.setQueryData(["userSettings"], data);
      console.log("Settings updated successfully:", data);
    },
    onError: (error: any) => {
      console.error("Error updating user settings:", error.response);
    },
  });

  return mutation;
};
